module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e9b82f49559c7a78e7e57bd07b3edd45.png";